<template>
  <div id="app">
    <router-view class="Router">
    </router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
.pc-show {
  display: block;
}
.h5-show {
  display: none;
}
.hover-btn {
  width: 100px;
  color: #fff;
  cursor: pointer;
  line-height: 38px;
  border-radius: 25px;
  margin-left: 20px;
  outline: none;
  font-size: 14px;
  background-color: $btn;
  position: relative;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  opacity: .999;
  overflow: hidden;
  background-image: linear-gradient(62deg, #ef9212 0%, #f0b40a 100%);
  &::before, &:after {
    content: '';
    width: 0;
    height: 100%;
    opacity: 0;
    position: absolute;
    top: 0;
    z-index: -1;
    background-color: #3ba8ff;
    transition: all 0.3s;
  }
  &::before {
    left: 50%;
  }
  &::after {
    right: 50%;
  }
  &:hover {
    border-color: #34495e;
    &:before {
      width: 50%;
      opacity: 1;
    }
    &:after {
      width: 50%;
      opacity: 1;
    }
  }
}
.mobile-header {
  color: #fff;
  background: $master-color6;
  position: relative;
  line-height: 45px;
  font-size: 16px;
  margin-top: 36px;
  .back {
    position: absolute;
    left: 10px;
    font-size: 22px;
  }
}
.bread-content {
  width: 100%;
  background: #f6f6f6;
  // background: pink;
  padding: 30px 0;
  .bread-left {
    font-size: 14px;
    line-height: 1;
    span {
      vertical-align: middle;
      font-size: 22px;
      margin-right: 5px;
    }
    em {
      vertical-align: middle;
    }
  }
}
.el-input__inner {
    padding: 0 10px;
  }
.getCode {
  position: relative;
  .el-input {
    padding-right: 120px;
  }
  .el-input__inner {
    padding: 0 7px;
  }
  .code {
    position: absolute;
    right: 30px;
    top: 0;
    .code-btn {
      display: block;
      width: 80px;
      color: #fff;
      background: $blue;
      height: 38px;
      line-height: 38px;
      outline: none;
      cursor: pointer;
      border-radius: 4px;
    }
    .second {
      text-align: center;
    }
  }
  .second {
    color: $sliver-color4;
  }
}
.pswDialog {
  height: 100%;
}
@media (max-width: $screen-sm-min){
  .pc-show {
    display: none;
  }
  .h5-show {
    display: block;
  }
  .bread-content {
    padding: 20px;
    .bread-main {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue